import FacilityReportingGridComponent from './facility-reporting-grid-component'
import FacilityReportingGridService from './facility-reporting-grid-service';
import popoverTemplate from '../facility-reporting-popover/facility-reporting-popover.html';

/***
 * A page that prompts a user to select one or more clients. Once they are selected, the user can view a facility
 * reporting grid for the given clients.
 */
const facilityReportingGrid = angular
    .module('FacilityData.FacilityReporting.FacilityReportingGrid', [])
    .component('facilityReportingGrid', FacilityReportingGridComponent)
    .service('FacilityReportingGridService', FacilityReportingGridService)
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider
            .state('app.facility-reporting.facility-reporting-grid', {
                url: '/facility-reporting/report/?clientIds&year',
                component: 'facilityReportingGrid',
                resolve: {
                    updateUser: (
                        $state,
                        $stateParams,
                        CurrentUser
                    ) => CurrentUser.updateCurrentUser({clients: $stateParams.clientIds}),
                    userAuth: (
                        $state,
                        updateUser,
                        CurrentUser
                    ) => {
                        if (!CurrentUser.canViewPage()) {
                            $state.go('app.home', {}, {reload: true});
                        }
                    },
                    reportList: (
                        $stateParams,
                        FacilityReportingGridService
                    ) => FacilityReportingGridService.getReport($stateParams.clientIds, $stateParams.year)
                }
            });
    })
    .run(($templateCache) => {
        'ngInject';
        $templateCache.put('facility-reporting-popover.html', popoverTemplate);
    })
    .name;

export default facilityReportingGrid;


// WEBPACK FOOTER //
// ./app/components/facility-reporting/facility-reporting-grid/facility-reporting-grid.js